import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, input, output } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { FileParameter } from '@fdm/api-client';

export interface NoteFile extends FileParameter {
  id: number;
}

@Component({
  selector: 'app-file-upload',
  imports: [CommonModule, MatLabel, MatButton, MatIcon, MatIconButton],
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadComponent {

  changed = output<FileParameter>();
  
  download = output<void>();
  
  delete = output<void>();

  label = input<string | null>('File');

  fileName = input<string | null>(null);

  file: File | null = null;

  constructor() {
    effect(() => {
      const fileName = this.fileName();

      if (!fileName) {
        this.file = null;
      }
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files?.length) {
      this.file = input.files[0];

      this.changed.emit({ data: this.file, fileName: this.file.name });
    }
  }
}
